export interface IVatCode {
    id: string,
    name: string,
    rate: number,
    is_default: boolean,
    reverse: string,
    type: VatCodeType
}

export enum VatCodeType { Standard = 0, ReverseCharge = 10 }